import React from 'react';
import VoxelAlertDialog from '../../../voxel/Dialogs/VoxelAlertDialog';
import VoxelDialogActionCancel from '../../../voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActions from '../../../voxel/Dialogs/VoxelDialogActions';
import VoxelDialogActionSubmit from '../../../voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogContent from '../../../voxel/Dialogs/VoxelDialogContent';
import { CancelDialogBag } from './useCancelDialog';
import VoxelText from '../../../voxel/Text/VoxelText';

export interface UnsavedChangesDialogProps {
  cancelDialogBag: CancelDialogBag;
}

export const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({ cancelDialogBag }) => {
  return (
    <VoxelAlertDialog
      severity="info"
      title="Unsaved changes"
      open={cancelDialogBag.showDialog}
      onClose={cancelDialogBag.handleCancel}
    >
      <VoxelDialogContent>
        <VoxelText>There are unsaved changes, how do you want to proceed?</VoxelText>
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={cancelDialogBag.handleCancel} />
        <VoxelDialogActionSubmit
          color="gray"
          title="Discard"
          onClick={cancelDialogBag.handleDiscardAndContinue}
        />
        <VoxelDialogActionSubmit
          title="Save"
          onClick={cancelDialogBag.handleSaveAndContinue}
        />
      </VoxelDialogActions>
    </VoxelAlertDialog>
  );
};

export default UnsavedChangesDialog;
